import { useState } from 'react';
import PromotionBanner from './component/PromotionBanner/index.js';
import MainLinksDesktop from './component/MainLinksDesktop/index.js';
import MainLinksMobile from './component/MainLinksMobile/index.js';
import CustomDrawer from './component/CustomDrawer/index.js';
import { Box } from '@mui/material';
import CustomContainer from '../../CustomContainer/index.js';
import ConfirmDialog from '../../ConfirmDialog';
import { useAuth } from '../../../contexts/AuthProvider';

export default function Header() {
    const [open, setOpen] = useState(false);
    const [signOutOpen, setSignOutOpen] = useState(false);
    const { signOut } = useAuth();

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const requestSignOut = () => {
        setOpen(false);
        setSignOutOpen(true);
    };

    return (
        <Box component="header" sx={styles.header}>
            <CustomDrawer open={open} toggleDrawer={toggleDrawer} onSignOut={requestSignOut} />
            <PromotionBanner />
            <CustomContainer>
                <MainLinksDesktop onSignOut={requestSignOut} />
                <MainLinksMobile toggleDrawer={toggleDrawer} />
            </CustomContainer>
            <ConfirmDialog
                open={signOutOpen}
                title="Sair da conta?"
                description="Você vai precisar entrar de novo para ver pedidos, orçamentos e o perfil."
                confirmLabel="Sair"
                onCancel={() => setSignOutOpen(false)}
                onConfirm={() => {
                    setSignOutOpen(false);
                    signOut();
                }}
            />
        </Box>
    );
}

const styles = {
    header: {
        position: 'sticky',
        top: 0,
        width: '100%',
        zIndex: 1200,
        bgcolor: 'primary.main',
        borderBottom: '2px solid',
        borderColor: 'secondary.main',
    },
};
